import { Box, Grid2, List, ListItem, Typography } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react';
import CourseAccordion from '../CourseAccordion/CourseAccordion';
// import GiftSubHero from '../SubHero/SubHero';
import MoreGifts from '../MoreItems/MoreItems';
import theme from '../../theme/theme';
import { useGet } from '../../hooks/useApi';
import CourseCardComponent from '../CardComponent/CardComponent';
import { useParams } from 'react-router-dom';

const CoursesDetailsDescription = ({courseOverviewDetails,courseItems}) => {
    const { data: courses, error: coursesErr, isLoading: coursesLoader } = useGet('/api/Courses/all-courses');
    // const [moreCourses, setMoreCourses] = useState([])
    const coursesList = useMemo(() => courses?.data || [], [courses]);
    const { id } = useParams();
   
   
    
    // useEffect(()=>{
    //     const MoreCoursesData = courseCategories?.filter((item)=>item?.name.toLowerCase().includes(category?.name?.toLowerCase()))
    //     setMoreCourses(MoreCoursesData)
      
    //   }, [category.id])
  
    // console.log(courseItems);
    
    // const your_why = [
    //     {
    //         desc:'You will learn techniques used by top marketers to attract, engage, and convert your audience.'
    //     },
    //     {
    //         desc:'You will understand the nuances of the Nigerian digital landscape and optimize your campaigns accordingly.'
    //     },
    //     {
    //         desc:'Benefit from a supportive network of fellow entrepreneurs and marketers.'
    //     },
    //     {
    //         desc:'With over 15,000 satisfied students, this course has a proven track record of transforming businesses.'
    //     },
    // ]
  return (
    <Box>
        <Box sx={{display:{xs:'block', md:'flex'}, gap:2, my:3,fontFamily: theme=> theme.typography.smallText,}}>
            <Box>
                <Box sx={{backgroundColor:'rgba(255, 255, 255, 1)', border:'1px solid rgba(243, 244, 246, 1)', p:2, borderRadius:'12px', width:'100%'}}>
               
                            <Typography variant='h6' style={{color:'rgba(57, 38, 89, 1)'}}>
                              {courseItems?.name}
                               </Typography>
                               <Typography sx={{width: '100%'}}>
                              {courseItems?.courseOverview
                              }
                               </Typography>
                  
                </Box>
                <Box sx={{backgroundColor:'rgba(255, 255, 255, 1)', border:'1px solid rgba(243, 244, 246, 1)', p:2,borderRadius:'12px', my:2,width:'100%'}}>
                    <Typography variant='h6' style={{color:'rgba(57, 38, 89, 1)'}}>
                    Why Choose This Course?
                    </Typography>
                    <ol>
                        {
                            courseOverviewDetails?.map((item,index)=>{
                                return <li key={index} style={{borderBottom:'1px solid rgba(241, 240, 242, 1)', marginLeft:'1rem', padding:'1rem 0'}}>{item}</li>
                            })
                        }
                    </ol>
                </Box>
            </Box>
            <Box sx={{backgroundColor:'rgba(241, 240, 242, 1)',border:'1px solid rgba(243, 244, 246, 1)', p:2, borderRadius:'12px',width:'100%'}}>
                <Typography variant='h6' style={{color:'rgba(57, 38, 89, 1)'}}>
                    Course Outline
                </Typography>
                <Box>
                    <CourseAccordion/>
                </Box>
            </Box>
            
        </Box>
        {/* <GiftSubHero/> */}
        {/* moreGifts={moreCourses} */}
        <MoreGifts title={'more courses'}  moreItems={coursesList}>
 

{
  coursesList
    ?.filter((item) => item.courseId.toString() !== id.toString()) // Filter out the courseId in the URL
    .slice(0, 3) // Show only the first 5 courses
    .map((item, index) => {
      return (
        <Grid2 item xs={2} key={index} size={{ xs: 12, md: 4 }}>
          <CourseCardComponent
            key={index}
            index={index}
            title={item.courseTitle}
            description={item.courseDescription}
            amount={item.price}
            detailspath={`course-details/${item.courseId}`}
            itemId={item.courseId}
            category={item?.name}
            rating={item.rating}
            amountText={`${item.soldCopy}k copies sold`}
            imageUrl={item.courseImagePath}
          />
        </Grid2>
      );
    })
}
        </MoreGifts>
    </Box>
  )
}

export default CoursesDetailsDescription